import { CompanyProfile } from '@mkp/company/models';
import { createAction, props } from '@ngrx/store';

export const updateCompany = createAction(
  '[Company Form Page] Update Company',
  props<{ company: CompanyProfile }>()
);
